const Controller = require("common/Controller");
const UserCache = require("logon/UserCache");
const Utils = require("common/Utils");

function LogonController(logonMessageView, logonView) {
    Controller.call(this);
    const self = this;
    const handlers = [];
    var activeLogonHandler;

    /**
     * @override
     * @inheritsDoc
     */
    self.getId = function() {
        return "LogonController";
    };

    self.subscribeToChannel("Electron", "logoff-user", function() {
        self.logoffUser();
    });

    self.subscribeTo("logoff-user", function() {
        self.logoffUser();
    });

    self.subscribeTo("cancel", function() {
        self.cancelLogon();
    });

    self.subscribeTo("login-as-diff-user", function() {
        self.logInAsDiffUser();
    });

    self.subscribeTo("logon-user", function(data, envelope) {
        const result = getActiveLogonHandler().logon(data);
        envelope.reply({promise : result});
    });

    const superSetNavManager = this.setNavManager;
    this.setNavManager = function(navManager) {
        superSetNavManager.call(this, navManager);

        handlers.forEach(function(entry) {
            entry.handler.setNavManager(navManager);
        });
    };

    this.registerHandler = function(handler, minVersion) {
        handlers.push({
            version : minVersion,
            handler : handler
        });

        handlers.sort(function(a, b) {
            return Utils.isGreaterThanOrEqualToServerVersion(a.version, b.version);
        });
    };

    this.getViews = function() {
        var views = [logonView, logonMessageView];

        handlers.forEach(function(entry) {
            views = views.concat(entry.handler.getViews());
        });

        return views;
    };

    $.ajaxSetup({
        // Globally set a redirect to the login page for any 401 responses
        statusCode : {
            401 : function() {
                const session = CudaLaunch.serverConfiguration.getSession();

                if (session) {
                    console.info("401 returned from server: redirecting to the login page");
                    CudaLaunch.controllers.RootController.showErrorDialog($.t("common::auth.expired.title"), false, undefined, function() {
                        self.logoffUser(true);
                    });
                }
            }
        }
    });

    $(document).on("connectionsuccessful", function(event, serverConfig) {
        onConnection(serverConfig);
    });

    function setActiveLogonHandler() {
        activeLogonHandler = handlers[0].handler;

        for (var i = 1; i < handlers.length; i++) {
            if (!Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, handlers[i].version)) {
                break;
            }

            activeLogonHandler = handlers[i].handler;
        }
    }

    function getActiveLogonHandler() {
        if (activeLogonHandler === undefined) {
            setActiveLogonHandler();
        }
        return activeLogonHandler;
    }

    function onConnection(serverConfig) {
        // Iterate through handlers and find the one for this server version
        if (handlers.length > 0) {
            setActiveLogonHandler();
            getActiveLogonHandler().onConnection(serverConfig, logonView);
        }
    }

    this.cancelLogon = function() {
        getActiveLogonHandler().cancel();
        self.logoffUser(true);
    };

    this.reset = function() {
        self.cancelLogon();
        self.resetNavigation();
        onConnection(CudaLaunch.serverConfiguration);
    };

    this.subscribeTo("access-denied", function() {
        if (!Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
            logonView.showError($.t("common::logon.accessDenied.title"), $.t("common::logon.accessDenied.message"));
            self.resetNavigation();
            self.showView(logonView);
        } else {
            logonView.reset();
            self.resetNavigation();
            getActiveLogonHandler().logon({}).then(function() {
                logonView.showError($.t("common::logon.accessDenied.title"), $.t("common::logon.accessDenied.message"));
            });
        }
    });

    /* Displays a message returned as a response to a login attempt */
    this.subscribeTo("show-error", function(data) {
        logonMessageView.setMessage(data.key, $.t("common::" + data.key, {
            clientProductName : Utils.getClientProductName(),
            serverProductName : Utils.getServerProductName(CudaLaunch.serverConfiguration.version),
            defaultValue : data.message
        }), data.noReturn);
        self.showView(logonMessageView, true);
    });

    this.subscribeTo("show-logon-view", function(data) {
        // Configure logon view with values from data
        logonView.configureAuthFields(data.usernameKey, data.authOptions);

        // Populate user creds as appropriate
        if (CudaLaunch.serverConfiguration.hostname === App.getDemoHostname()) {
            logonView.setDemoCreds("guest", "guest");
        } else {
            if (CudaLaunch.serverConfiguration.allowRememberMe) {
                var username = UserCache.getUsernameForHost(CudaLaunch.serverConfiguration.hostname);
                logonView.setUsername(username);
            }
        }

        self.showView(logonView);
    });

    function sendPing(apiRoot) {
        // If the client thinks we are currently logged in, check that the server does as well
        var ajaxPingSettings = {
            url : apiRoot + "ping",
            type : "GET",
            dataType : "text",
            timeout : 3000,
            retries : 3,
            done : function(data) {
                if (data !== "ok") {
                    console.debug("user session is no longer valid");
                    self.logoffUser(true);
                }
            },
            fail : function(jqXHR) {
                if (jqXHR.status === 0 && ajaxPingSettings.retries > 0) {
                    ajaxPingSettings.retries--;
                    $.ajax(ajaxPingSettings);
                } else if (jqXHR.status !== 401) {
                    console.error("failed to check user session, status = " + jqXHR.status);
                    self.logoffUser(true);
                }
            }
        };
        return $.ajax(ajaxPingSettings);
    }

    $(document).on("userunauthenticated", function() {
        $(document).off("appresumed.ping");
    });

    $(document).on("userauthenticated", function() {
        $(document).on("appresumed.ping", function() {
            sendPing(App.getApiRoot());
        });
    });

    $(document).on("totp-authenticated", function() {
        if (App.isSSLVPNApp()) {
            $(document).off("appresumed.ping");
            $(document).on("appresumed.ping", function() {
                sendPing("/sslvpn_api/")
                    .done(function() {
                        sendPing("/totp_api/");
                    });
            });
        }
    });

    this.logoffUser = function(force) {
        var session = CudaLaunch.serverConfiguration.getSession();

        if (session) {
            var doLogoff = function() {
                self.publishEvent("TOTPSettingsDelegate", "logoff-user");

                console.debug("logging off user");

                CudaLaunch.serverConfiguration.clearSession();

                getActiveLogonHandler().logoff();
            };

            if (force) {
                doLogoff();
            } else {
                var willLogoffEvent = $.Event("will-logoff");
                var promises = [];
                $(document).trigger(willLogoffEvent, [promises]);

                $.when.apply($, promises).then(function() {
                    if (!willLogoffEvent.isDefaultPrevented()) {
                        doLogoff();
                    }
                });
            }
        } else {
            $.event.trigger("userunauthenticated");
        }
    };

    this.logInAsDiffUser = function() {
        getActiveLogonHandler().cancel();
        UserCache.removeUsernameForHost(CudaLaunch.serverConfiguration.hostname);
        logonView.setUsername("");
        self.logoffUser(true);
    };

    /**
     * @override
     * @inheritsDoc
     */
    this.setState = function() {
        // We don't have any state of our own, we just need to use the existing server configuration
        onConnection(CudaLaunch.serverConfiguration);
    };

    /**
     * @override
     * @inheritsDoc
     */
    this.getState = function() {
        // Need to return something so that we are asked to restore the state on reload
        return {};
    };
}

Utils.inherits(LogonController, Controller);

module.exports = LogonController;